require([
    'lib/globalize',
    'jquery',
    'lib/bluebird',
    'lib/knockout',
    'viewModels/appView',
    'routes',
    'config',
    'services/authService',
    'services/componentLoader',
    'services/embeddingService',
    'services/localeService',
    'services/loggingService',
    'text!components.json',
    'text!../css/lib/styleGuide/svg-icons.svg',

    // Knockout bindings we want to use, do not add them to the function's arguments
    // (unless you actually need them)
    'bindingHandlers/advancedUserSelect',
    'bindingHandlers/advanceFocusForGUID',
    'bindingHandlers/accordion2/accordion2',
    'bindingHandlers/accordion2/animateAccordion',
    'bindingHandlers/phoneAddress',
    'bindingHandlers/attr',
    'bindingHandlers/audio/audioPlayerNavigation',
    'bindingHandlers/audio/audioPlayerSetup',
    'bindingHandlers/audio/waveform',
    'bindingHandlers/autocomplete',
    'bindingHandlers/autoFocus',
    'bindingHandlers/barChart',
    'bindingHandlers/columnChart',
    'bindingHandlers/binaryHeatMap',
    'bindingHandlers/btnGroupSelector',
    'bindingHandlers/carousel',
    'bindingHandlers/chartLegend',
    'bindingHandlers/chatScroll',
    'bindingHandlers/clearInput',
    'bindingHandlers/clickCopy',
    'bindingHandlers/clickOnce',
    'bindingHandlers/combobox',
    'bindingHandlers/contentTypeName',
    'bindingHandlers/csvErrorDisplay',
    'bindingHandlers/csvList',
    'bindingHandlers/datePicker',
    'bindingHandlers/dateRangePicker',
    'bindingHandlers/percentPicker',
    'bindingHandlers/percentRangePicker',
    'bindingHandlers/dialog',
    'bindingHandlers/downloadContent',
    'bindingHandlers/dropdown',
    'bindingHandlers/durationPicker',
    'bindingHandlers/durationRangePicker',
    'bindingHandlers/numberPicker',
    'bindingHandlers/numberRangePicker',
    'bindingHandlers/editableText',
    'bindingHandlers/error',
    'bindingHandlers/featureToggle',
    'bindingHandlers/notFeatureToggle',
    'bindingHandlers/flipswitch',
    'bindingHandlers/fileInputSelection',
    'bindingHandlers/dataTable/dataTable',
    'bindingHandlers/dataTable/dynamicColumnsDataTable',
    'bindingHandlers/dataTable/endlessDataTable',
    'bindingHandlers/agentInfoTable',
    'bindingHandlers/fixedVerticalNavigation',
    'bindingHandlers/include',
    'bindingHandlers/integerPicker',
    'bindingHandlers/renderComponent',
    'bindingHandlers/inlineDialog',
    'bindingHandlers/lineChart',
    'bindingHandlers/loadIndicator',
    'bindingHandlers/inlineConfirmation',
    'bindingHandlers/switchedInclude',
    'bindingHandlers/tooltip',
    'bindingHandlers/waitButton',
    'bindingHandlers/viewSwitch',
    'bindingHandlers/carousel',
    'bindingHandlers/tooltip',
    'bindingHandlers/tooltip2',
    'bindingHandlers/lTooltip',
    'bindingHandlers/afterForEach',
    'bindingHandlers/fakeLabel',
    'bindingHandlers/slideDown',
    'bindingHandlers/tabbable',
    'bindingHandlers/dynamicWidth',
    'bindingHandlers/dragDropBlock',
    'bindingHandlers/droparea',
    'bindingHandlers/validation/form',
    'bindingHandlers/validation/formGroup',
    'bindingHandlers/validation/formControl',
    'bindingHandlers/validation/controlMessage',
    'bindingHandlers/paste',
    'bindingHandlers/popover',
    'bindingHandlers/popover2',
    'bindingHandlers/resize',
    'bindingHandlers/radial',
    'bindingHandlers/timeInput/timeInputBinding',
    'bindingHandlers/isEventTargetWithin',
    'bindingHandlers/transferBox',
    'bindingHandlers/toggleClick',
    'bindingHandlers/privileged/inheritedFormControl',
    'bindingHandlers/selectOnFocus',
    'bindingHandlers/selectOptions',
    'bindingHandlers/sortableList',
    'bindingHandlers/scrollSnap',
    'bindingHandlers/scrollTop',
    'bindingHandlers/numberDisplay',
    'bindingHandlers/weekPicker',
    'bindingHandlers/timeline',
    'bindingHandlers/datePicker2',
    'bindingHandlers/dateRangePicker2',
    'bindingHandlers/webComponent',

    'extensions/i18n/knockout.lDuration',

    // Composer binding handlers
    'bindingHandlers/composer/formEditorWeight',

    // Extension shims for 3rd party libraries.
    'lib/knockout.dragdrop',
    'extensions/knockout.validation.extender',

    // Custom Knockout extenders
    'extensions/knockoutExtenders/trimmed',
    'extensions/knockoutExtenders/byteConverter',
    'extensions/knockoutExtenders/deepComparer',
    'extensions/knockoutExtenders/numeric',
    'extensions/i18n/knockout.i18n',

     // Referenced here to avoid being ripped out when optimized.  Used by at least the WFM component
    'lib/moment-timezone',
    'lib/knockout-sortable',
    'lib/intl-tel-input/intlTelInput',

     'wem-webcomponents/wem-webcomponents.main',
     'genesys-webcomponents/genesys-webcomponents.main'

],
function (
    globalize,
    $,
    Promise,
    ko,
    appView,
    routes,
    config,
    authService,
    componentLoader,
    embeddingService,
    localeService,
    LOG,
    components,
    svgIcons
) {
    'use strict';
    var componentDef = JSON.parse(components);

    window.onerror = function () {
        var args = Array.prototype.slice.apply(arguments);
        LOG.error('window.error caught unhandled error', args);
    };

    Promise.onPossiblyUnhandledRejection(function(e){
        LOG.warn("Possibly unhandled exception", e);
    });

    $('body').prepend(svgIcons);

    function startup() {
        localeService.loadLocale( localeService.getAppLocale() )
            .then(function (loadedLocale) {
                ko.i18n.setLocale(loadedLocale);
                $('html').attr('lang', loadedLocale);
                LOG.debug("App initialized with locale", loadedLocale);
                return componentLoader.registerComponents(componentDef);
            })
            .then(function () {
                ko.applyBindings(appView); // Attach the root ViewModel to Knockout.
                routes.run(); // Let the route system update the app state.
                $('.content-wrapper').removeClass('pending-init'); // Show the application, which was hidden until now.
                embeddingService.notifyInitialized();
            })
            .catch(function (error) {
                LOG.error('Error during applicaton boostrap', error);
            });
    }

    if (authService.initialized()) {
        startup();
    }
    authService.initialized.subscribe(startup);

});

define("app", function(){});

